import { css } from '@emotion/core'
import { colors } from '@fs/zion-ui'

export default {
  internalCheckbox: css`
    background-color: ${colors.gray03};
    padding: 0 16px;
  `,
  radioSection: css`
    background-color: ${colors.gray03};
    margin-top: 4px;
    margin-bottom: 8px;
    padding: 0 16px;
    padding-top: 10px;
  `,
  rowWithLock: css`
    align-items: center;
    display: flex;
    justify-content: space-between;
  `,
  optionsSubheader: css`
    font-size: 14px;
  `,
}
